import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormulaBlueService {
  
  formulaBluePayLoad$ = new BehaviorSubject(null);
  
  constructor(private http: HttpClient, private occService: OccEndpointsService,) { }

  getProdDetails(){
    return this.http.get(this.occService.buildUrl(`products/fetchproducttypes`));
  }
  
  getYearDetails(productType){
    return this.http.get(this.occService.buildUrl(`products/fetchyears?productType=${productType}`));
  }
  getMakeDetails(productType,year){
    return this.http.get(this.occService.buildUrl(`products/fetchmakes?productType=${productType}&year=${year}`));
  }
  getModelDetails(productType,year,make){
    return this.http.get(this.occService.buildUrl(`products/fetchmodels?productType=${productType}&year=${year}&make=${make}`));
  }

  submitFormulaData(data,pageSize?, searchQuery?, currentPage?, sort?) {
    return this.http.post(this.occService.buildUrl(`products/formulablue/searchresult?fields=FULL&pageSize=${pageSize}&currentPage=${currentPage}&query=${searchQuery}&sort=${sort}`),data);
  }
}
